import React, { Component, } from 'react'
import PropTypes from 'prop-types'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

import Button from 'components/_atoms/Button'
import MenuIcon from 'components/icons/Menu'
import CrossCircleIcon from 'components/icons/CrossCircle'

import './styles.css'

class MagicMenu extends Component {
  static propTypes = {
    menuOptions: PropTypes.arrayOf(
      PropTypes.shape({
        action: PropTypes.func.isRequired,
        label: PropTypes.string.isRequired,
      })
    ).isRequired,
    discreet: PropTypes.bool,
  }

  static defaultPropTypes = {
    discreet: false,
  }

  state = {
    menuOpen: false,
  }

  componentWillReceiveProps(nextProps){
    // hack: close the menu whenever new props are received (e.g. a scene change)
    this.setState({
      menuOpen: false,
    })
  }

  openMenu = () => {
    this.setState({
      menuOpen: !this.state.menuOpen,
    })
  }

  renderMenuOptions = () =>
    (<div className="magic-menu-options">
      {this.props.menuOptions.map(option =>
        (<div className="magic-menu-option" key={option.label}>
          <Button
            inverse
            onClick={() => {
              option.action()
            }}
          >
            {option.label}
          </Button>
        </div>)
      )}
    </div>)

  render() {
    const { discreet } = this.props
    const { menuOpen, } = this.state
    const containerClass = (discreet) ? "magic-menu-container discreet" : "magic-menu-container";
    return (
      <div className={containerClass}>
        <ReactCSSTransitionGroup
          transitionName="magic-menu-transition"
          transitionEnterTimeout={400}
          transitionLeaveTimeout={400}
        >
          {menuOpen && this.renderMenuOptions()}
        </ReactCSSTransitionGroup>
        <button className="magic-menu-button" onClick={this.openMenu}>
          {!menuOpen && <MenuIcon customClassName="menu-icon" width={50} />}
          {menuOpen &&
            <CrossCircleIcon customClassName="menu-icon" width={50} />}
        </button>
      </div>
    )
  }
}

export default MagicMenu



// WEBPACK FOOTER //
// ./src/components/MagicMenu/index.js